<div class="validation-error-details-dialog">
  <div mat-dialog-title class="flex items-center justify-between border-b border-gray-200 dark:border-gray-700 pb-4 !mb-0">
    <div>
      <h2 class="text-2xl font-bold text-gray-900 dark:text-white">Błąd Walidacji</h2>
      <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
        {{ data.documentNumber }} • {{ data.timestamp | date: 'dd.MM.yyyy HH:mm' }}
      </p>
    </div>
    <button mat-icon-button (click)="close()">
      <mat-icon svgIcon="tabler_outline:x"></mat-icon>
    </button>
  </div>

  <mat-dialog-content class="!p-0 !mt-0">
    <mat-tab-group>
      <!-- Błędy Tab -->
      <mat-tab label="Błędy">
        <div class="p-6">
          <!-- Error Code & Message -->
          <div class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-6">
            <div class="flex items-start mb-3">
              <mat-icon 
                class="!w-6 !h-6 text-red-600 dark:text-red-400 mr-3 flex-shrink-0"
                svgIcon="tabler_outline:alert-triangle"
              ></mat-icon>
              <div class="flex-1">
                <div class="flex items-center mb-2">
                  <mat-chip class="font-mono text-xs mr-2" color="warn">
                    {{ data.error?.code || 'VALIDATION_FAILED' }}
                  </mat-chip>
                  <button 
                    mat-icon-button 
                    (click)="copyErrorToClipboard()"
                    matTooltip="Kopiuj błąd do schowka"
                    class="!w-8 !h-8"
                  >
                    <mat-icon class="!w-4 !h-4" svgIcon="tabler_outline:copy"></mat-icon>
                  </button>
                </div>
                <div class="text-sm font-semibold text-red-900 dark:text-red-300">
                  {{ data.error?.message || 'Błąd walidacji' }}
                </div>
              </div>
            </div>
          </div>

          <!-- AI Helper Button -->
          <button 
            mat-raised-button 
            color="accent"
            class="w-full mb-6"
            (click)="copyAllForAI()"
          >
            <mat-icon svgIcon="tabler_outline:sparkles" class="mr-2"></mat-icon>
            <span class="font-semibold">Kopiuj błąd + JSON + prompt dla AI</span>
          </button>
          <p class="text-xs text-center text-gray-500 dark:text-gray-400 mb-6">
            Jednym kliknięciem skopiuj wszystko gotowe do wklejenia w ChatGPT/Claude
          </p>

          <!-- Error Details -->
          <div *ngIf="data.error?.details && data.error.details.length > 0" class="space-y-4">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-3">
              Szczegóły błędów ({{ data.error.details.length }})
            </h3>
            
            <div 
              *ngFor="let detail of data.error.details; let i = index"
              class="bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4"
            >
              <div class="flex items-start">
                <div class="flex-shrink-0 w-6 h-6 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mr-3 mt-0.5">
                  <span class="text-xs font-bold text-red-600 dark:text-red-400">
                    {{ i + 1 }}
                  </span>
                </div>
                <div class="flex-1">
                  <!-- Code -->
                  <div *ngIf="detail.code" class="mb-2">
                    <mat-chip class="!text-xs font-mono">{{ detail.code }}</mat-chip>
                  </div>
                  
                  <!-- Field -->
                  <div *ngIf="detail.field" class="text-sm mb-2">
                    <span class="font-semibold text-gray-700 dark:text-gray-300">Pole:</span>
                    <code class="ml-2 px-2 py-0.5 bg-gray-200 dark:bg-gray-700 rounded text-xs">
                      {{ detail.field }}
                    </code>
                  </div>
                  
                  <!-- Message -->
                  <div class="text-sm mb-2">
                    <span class="font-semibold text-gray-700 dark:text-gray-300">Komunikat:</span>
                    <p class="mt-1 text-gray-600 dark:text-gray-400">
                      {{ detail.message }}
                    </p>
                  </div>
                  
                  <!-- Value -->
                  <div *ngIf="detail.value !== undefined && detail.value !== null" class="text-sm mb-2">
                    <span class="font-semibold text-gray-700 dark:text-gray-300">Wartość:</span>
                    <code class="ml-2 px-2 py-0.5 bg-yellow-100 dark:bg-yellow-900/30 text-yellow-900 dark:text-yellow-400 rounded text-xs">
                      {{ detail.value }}
                    </code>
                  </div>
                  
                  <!-- Expected -->
                  <div *ngIf="detail.expected" class="text-sm">
                    <span class="font-semibold text-gray-700 dark:text-gray-300">Oczekiwano:</span>
                    <p class="mt-1 text-gray-600 dark:text-gray-400 text-xs">
                      {{ detail.expected }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- No Details -->
          <div *ngIf="!data.error?.details || data.error.details.length === 0" class="text-center py-8 text-gray-500">
            <mat-icon class="!w-12 !h-12 mb-2" svgIcon="tabler_outline:info-circle"></mat-icon>
            <p>Brak szczegółowych informacji o błędzie</p>
          </div>
        </div>
      </mat-tab>

      <!-- JSON Tab -->
      <mat-tab label="JSON Faktury">
        <div class="p-6">
          <div class="space-y-4">
            <!-- JSON Actions -->
            <div class="flex items-center justify-between mb-4">
              <div class="text-sm text-gray-600 dark:text-gray-400">
                Pełny dokument faktury w formacie JSON
              </div>
              <button 
                mat-stroked-button 
                (click)="copyJsonToClipboard()"
              >
                <mat-icon svgIcon="tabler_outline:copy"></mat-icon>
                Kopiuj JSON
              </button>
            </div>

            <!-- JSON Viewer Component -->
            <app-json-viewer 
              [json]="data.documentJson"
              [maxHeight]="'500px'">
            </app-json-viewer>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="border-t border-gray-200 dark:border-gray-700 pt-4">
    <button mat-button (click)="close()">Zamknij</button>
  </mat-dialog-actions>
</div>

